import { Reveal } from "./Reveal";
import { scrollToSection } from "@/lib/scroll";
import { ArrowRight } from "lucide-react";

const CHAPTERS = [
  {
    title: "The Agency",
    text: "RK Tourism & Travel is a UAE-based travel house designing journeys across eleven remarkable destinations — from America's national parks to the temples of Thailand and the skylines of home.",
  },
  {
    title: "The Craft",
    text: "Tours, visit visas, entry permissions, flights and stays — every detail is handled under one roof by people who know the routes, the rules and the quiet corners worth finding.",
  },
  {
    title: "The Promise",
    text: "No copied itineraries, no hidden extras, no call centres. Just honest advice, transparent pricing and a travel designer who answers when you call — before, during and after your journey.",
  },
];

export default function Manifesto() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-12 gap-14">
        <div className="md:col-span-5">
          <div className="md:sticky md:top-36">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] font-medium mb-6">
                Our Manifesto
              </p>
              <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight leading-tight text-slate-50">
                Travel, composed{" "}
                <span className="italic text-[#d4af37]">like art.</span>
              </h2>
              <p className="mt-6 text-slate-400 leading-relaxed max-w-sm">
                We believe a journey should read like a well-written story —
                unhurried, personal and impossible to forget.
              </p>
              <button
                data-testid="about-cta"
                onClick={() => scrollToSection("#booking")}
                className="group mt-8 flex items-center gap-3 text-sm tracking-[0.15em] uppercase text-[#d4af37] hover:text-[#f3e5ab] transition-colors"
              >
                Start your story
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>
        </div>
        <div className="md:col-span-7">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.1}>
              <div className="border-t border-[#d4af37]/20 py-12 grid sm:grid-cols-12 gap-6">
                <span className="sm:col-span-3 font-display text-xl text-[#d4af37]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="sm:col-span-9">
                  <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tight text-slate-50 mb-4">
                    {c.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-[#d4af37]/20" />
        </div>
      </div>
    </section>
  );
}
